import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import { motion } from "framer-motion";
import './App.css';
import './Chatbot.css';
import Chatbot from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";
import config from "./chatbotConfig";
import MessageParser from "./MessageParser";
import ActionProvider from "./ActionProvider";

import heroImage from './assets/undraw_success-factors_i417.svg';
import aboutImage from './assets/undraw_in-the-office_e7pg.svg';

import Generator from './pages/Generator';  // Importuj Generator
import HomeDetails from './pages/AboutDetails';
import Services from './pages/Services';
import PricingDetails from './pages/PricingDetails';
import WebsiteGeneratorForm from './components/WebsiteGeneratorForm';
import WebsiteGenerator from './components/WebsiteGenerator';



function Home() {
  const [darkMode, setDarkMode] = useState(false);
  const [showBot, setShowBot] = useState(false);

  useEffect(() => {
    document.body.className = darkMode ? 'dark-mode' : '';
  }, [darkMode]);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <header className="header">
        <Link to="/" className="logo">SiteForge AI</Link>
        <nav className="navbar">
          <Link to="/" className="active">Strona główna</Link>
          <Link to="/about">O nas</Link>
          <Link to="/services">Funkcje</Link>
          <Link to="/pricing">Cennik</Link>
          <Link to="#contact">Kontakt</Link>
          <button onClick={() => setDarkMode(!darkMode)} className="dark-mode-toggle">
            {darkMode ? '🌞 Jasny tryb' : '🌙 Ciemny tryb'}
          </button>
        </nav>
      </header>

      <section className="home" id="home">
        <div className="home-content">
          <h3>Witaj w</h3>
          <h1>SiteForge AI</h1>
          <p>Twórz profesjonalne strony internetowe generowane przez AI w kilka sekund. Wybierz styl, podaj informacje i ciesz się gotową stroną!</p>
          <div className="social-media">
            <a href="#"><i className="bx bxl-facebook"></i></a>
            <a href="#"><i className="bx bxl-instagram"></i></a>
            <a href="#"><i className="bx bxl-linkedin"></i></a>
          </div>
          <Link to="/generator" className="btn">🛠 Generuj stronę</Link> {/* tutaj zmieniamy link */}
        </div>
        <div className="home-img">
          <img src={heroImage} alt="SiteForge Hero" className="responsive-img" />
        </div>
      </section>
    </motion.div>
  );
}

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [showBot, setShowBot] = useState(false);

  useEffect(() => {
    document.body.className = darkMode ? 'dark-mode' : '';
  }, [darkMode]);

  return (
    <BrowserRouter>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <header className="header">
          <Link to="/" className="logo">SiteForge AI</Link>
          <nav className="navbar">
            <Link to="/" className="active">Strona główna</Link>
            <a href="#about">O nas</a>
            <a href="#services">Funkcje</a>
            <a href="#pricing">Cennik</a>
            <a href="#contact">Kontakt</a>
            <button onClick={() => setDarkMode(!darkMode)} className="dark-mode-toggle">
              {darkMode ? '🌞 Jasny tryb' : '🌙 Ciemny tryb'}
            </button>
          </nav>
        </header>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/generate" element={<WebsiteGenerator />} />
        </Routes>

        <div className="chatbot-toggle-wrapper">
          <button className="chatbot-toggle" onClick={() => setShowBot(!showBot)}>
            {showBot ? '❌ Zamknij Chatbota' : '💬 Otwórz Chatbota'}
          </button>
          {showBot && (
            <div className="chatbot-wrapper">
              <Chatbot
                config={config}
                messageParser={MessageParser}
                actionProvider={ActionProvider}
              />
            </div>
          )}
        </div>

        <footer className="footer">
          <div className="footer-text">
            <p>© 2025 SiteForge AI — Wszystkie prawa zastrzeżone.</p>
          </div>
          <div className="footer-iconTop">
            <a href="#home"><i className="bx bx-up-arrow-alt"></i></a>
          </div>
        </footer>
      </motion.div>
    </BrowserRouter>
  );
}

export default App;
